<template>
  <div class="detail_main">
    <div class="is-hidden-touch">
      <div
        @click="$emit('close')" 
        :class="{'bg_detail': bg}"
        class="detail_container">
      </div>
      <section class="size_detail zero_right mt-60 pb-60 is-scrollable has-background-white">
        <div class="columns is-marginless detail_content_bg">
          <figure class="maxheight half_width is-relative" v-if="!streetView">
            <button class="button is-primary btn_StreetVieuwPann">
              <img src="@/assets/images/google-street-view.svg" class="mr-5">
              <span class="is-size-14px" @click="streetView = true">Streetview</span>
            </button>
            <img class="is-width-100p" :src="getImg(detailPanneau.urlLogo)">
          </figure>
          <figure class="maxheight half_width is-relative" v-else>
            <CartoPanneau
              :streetView="streetView"
              :panneau="detailPanneau"/>
          </figure>
          <div class="half_width ml-20 mt-20 mr-20">
            <a @click="$emit('close')"
              class="detail_icon_close_right">
              <b-icon
                icon="window-close"
                size=""
                type="is-grid-5">
              </b-icon>
            </a>
            <h3 class="has-text-grid-1 has-text-weight-bold is-size-6 mb-20">
              Caractéristiques :
            </h3>
            <caracteristiques :data="detailPanneau"/>
          </div>
        </div>
        <div class="columns is-marginless is-multiline  ml-20 mr-20">
          <div class="column is-6 is-paddingless pr-10 mt-20"
						v-for="(budget, i) in detailPanneau.budgets" :key="i">
            <budget :data="budget"/>
          </div>
          <div v-if="detailPanneau.commentaire" class="column is-12 mt-20 is-paddingless">
            <p class="is-size-6 has-text-grid-1 has-text-weight-bold">Argumentaire :</p>
            <p class="is-size-14px has-text-grid-1 pre-line-text">{{detailPanneau.commentaire}}</p>
          </div>
        </div>
      </section>
    </div>
    <div class="is-hidden-desktop">
      <div class="detail_container has-background-white is-overflow-y-active">

        <figure class="card-img-panneau">

          <a class="button has-text-white is-rounded has-background-grid-5 btn-back"
            @click="$emit('close')">
            <span class="icon">
              <b-icon icon="chevron-left"></b-icon>
            </span>
            <label class="is-size-10px">Retour</label>
          </a>
          <img class="img-panneau" :src="getImg(detailPanneau.urlLogo)">

        </figure>

        <b-tabs class="detail-panneau mb-60" size="is-small" v-model="valueTabs">
          <b-tab-item v-for="(item, i) in tabsItem" :key="i">
            <template slot="header">
              <span class="has-text-weight-bold" :class="{'is-underline': valueTabs === i}">
                {{item.title}}
              </span>
            </template>
            <component
              :is="item.component"
              :data="item.data"/>
          </b-tab-item>
        </b-tabs>

      </div>
    </div>
  </div>
</template>

<script>
import { formatDate, getImg, formatNombre } from '@/services/general/general';
import Caracteristiques from './detailPanneau/caracteristiques';
import Budget from './detailPanneau/budget';
import CartoPanneau from './CartoPanneau'

export default {
  components: {
    Caracteristiques,
    Budget,
    CartoPanneau
  },
  props: {
    detailPanneau: Object,
    bg: Boolean,
  },
  data: () => ({
    valueTabs: 0,
    streetView: false,
  }),
	computed: {
		tabsItem() {
			let tabsItem = [
				{ title: 'Caractéristiques', component: 'Caracteristiques', data: this.detailPanneau },
			];
			this.detailPanneau.budgets.forEach(budget => {
				tabsItem.push({ title: `Budget ${formatDate(budget.dateDebut, 'YYYY')}`, component: 'Budget', data: budget });
			});
			return tabsItem;
		},
	},
  methods: {
    getImg: getImg,
    formatDate: formatDate,
    formatNombre: formatNombre,
  },
  mounted() {
    const elHtml = document.querySelector('html');
    const elBody = document.querySelector('body');
    elHtml.style.overflow = 'hidden';
    elBody.style.overflow = 'hidden';
  },
  destroyed() {
    const elHtml = document.querySelector('html');
    const elBody = document.querySelector('body');
    elHtml.style.overflow = '';
    elBody.style.overflow = '';
  },
}
</script>
